<template>
  <div id="VisualizarProcesadoBaja_div">
    <div id="encabezado-" class="form-inline justify-content-between">
      <h5>{{tituloDeInformacion}}</h5>
    </div>
    <hr class="mt-2" />
    <div >

         </div>

        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Clave del Procesado:</h6>

          <h6 :class="'catalogoInformativo'">{{clave_del_procesado}}</h6>
         
        </div>


         <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">     
          <h6>Nombre:</h6>

         <h6 :class="'catalogoInformativo'"> {{nombre}} {{apellido_paterno}} {{apellido_materno}} </h6>

        </div>


        <div  class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Dirección:</h6>

          <h6 :class="'catalogoInformativo'">{{direccion}}</h6>
         
        </div>

        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Municipio:</h6>

          <h6 :class="'catalogoInformativo'">{{municipioNombre}}</h6>

          
        </div>


        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Entidad Federativa:</h6>

          <h6 :class="'catalogoInformativo'">{{entidadFederativaNombre}}</h6>

          
        </div>



        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Partido Judicial:</h6>

         <!-- <h6 :class="'catalogoInformativo'"> {{partidoJudicialNombre}} </h6> -->

         <h6 :class="'catalogoInformativo'" id="listado_delitos" >
                                <li v-for="partidoJudicialNombre in (partidoJudicialNombre)">
                                    {{partidoJudicialNombre.PartidoJudicial.Nombre}}
                                </li>
                            </h6> 

        </div>


        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Juzgado:</h6>

          <!-- <h6 :class="'catalogoInformativo'">{{areaNombre}}</h6> -->

          <h6 :class="'catalogoInformativo'" id="listado_delitos" >
                                <li v-for="areaNombre in (areaNombre)">
                                    {{areaNombre.Area.Nombre}}
                                </li>
                            </h6>

          
        </div>


        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Materia:</h6>

          <!-- <h6 :class="'catalogoInformativo'">{{materiaNombre}}</h6> -->

          <h6 :class="'catalogoInformativo'" id="listado_delitos" >
                                <li v-for="materiaNombre in (materiaNombre)">
                                    {{materiaNombre.Materia.Nombre}}
                                </li>
                            </h6>

           
        </div>


        <!-- <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Delito:</h6>

          <h6 :class="'catalogoInformativo'">{{delitoNombre}}</h6>

          
        </div> -->


        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Delito/os:</h6>

         <!--  <h6 :class="'catalogoInformativo'">{{delitoNombre}}</h6> -->


          <h6 :class="'catalogoInformativo'" id="listado_delitos" >
                                <li v-for="delitoNombre in (delitoNombre)">
                                    {{delitoNombre.Delito.Nombre}}
                                </li>
                            </h6>

          
        </div>


        <div  class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Tipo de documento:</h6>

          <!-- <h6 :class="'catalogoInformativo'">{{tipoDocumentoNombre}}</h6> -->


          <h6 :class="'catalogoInformativo'" id="listado_delitos" >
                                <li v-for="tipoDocumentoNombre in (tipoDocumentoNombre)">
                                    {{tipoDocumentoNombre.TipoDocumento.Nombre}}
                                </li>
                            </h6>


        </div>



        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Consecutivo:</h6>

          <!-- <h6 :class="'catalogoInformativo'">{{consecutivo}}</h6> -->

          <h6 :class="'catalogoInformativo'" id="listado_delitos" >
                                <li v-for="consecutivo in (consecutivo)">
                                    <!-- {{consecutivo.Expediente.Consecutivo}} -->
                                    {{ (consecutivo.Expediente.NumeroRomano ? (consecutivo.Expediente.Consecutivo + '-' + consecutivo.Expediente.NumeroRomano) : consecutivo.Expediente.Consecutivo) }}
                                </li>
                            </h6>

        </div>


        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Temporalidad:</h6>

          <h6 :class="'catalogoInformativo'">{{temporalidadNombre}} días</h6>
         
        </div>


        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Fecha de alta:</h6>

          <h6 :class="'catalogoInformativo'">{{fechaDeAlta}}</h6>

        </div>
        

        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xlg-4 mb-4 ml-0 pl-1">
          <h6>Fecha de baja:</h6>

          <h6 :class="'catalogoInformativo'">{{fechaDeBaja}}</h6>

        </div>  




        <div class="d-flex" style="height: 50px;">
        <div class="vr"></div>
        </div>  
         
        

       
   





      
    <!-- Boton salir -->
    <div class="d-flex row">
        <div  class="col-12 col-sm-12 col-md-4 col-lg-4 col-xlg-4 pb-2 text-left">
            
             

             <button type="button" class="btn btn-danger overwrapDeBotones mr-3"  @click="Botoncancelar()"><i class="fas fa-window-close fa-lg"></i>&nbsp;&nbsp;Salir</button>

        </div>


        <div class="d-sm-none d-md-none d-lg-block col-lg-1 col-xlg-1"></div>
        
    </div>



  </div >
  </div>
</template>
<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import catalogos from '@/../static/js/catalogos'
  import { mapActions } from 'vuex'
  import VueMask from 'v-mask'
  import axios from 'axios'
  import api from '@/../static/js/api'

  Vue.use(VueMask);

  export default {
    data() {
      return {
        togglePerspectivaRender: 1,
        enumeraciones,
        tipoEstatusFirmaId:-1,
        partidoJudicialId: -1,
        materiaId: -1,
        delitoId: -1,
        rubroId: -1,
        areaId: -1,
        tipoDocumentoId: -1,
        entidadFederativaId: -1,
        municipioId: -1,
        temporalidadId: -1,
        nombre:null,
        apellido_paterno: null,
        apellido_materno: null,
        direccion: null,
        consecutivo: null,
        
       }  
              

    },
    props: {
      esAlta:true,
      tituloDeInformacion: String,
      VisualizarProcesadosBaja:Object
    },
    components: {
      C007TiposEstatusFirma: catalogos.SIVAC.C007TiposEstatusFirma,
      C009PartidosJudiciales: catalogos.PJ.C009PartidosJudiciales,
      C002Materias: catalogos.PJ.C002Materias,
      C001Area: catalogos.PJ.C001Area,
      C004TiposDocumento: catalogos.PJ.C004TipoDocumento,
      C008Delitos: catalogos.PJ.C008Delitos,
      C006TiposRubro: catalogos.SIVAC.C006TiposRubro,
      C010Municipios: catalogos.PJ.C010Municipios,
      C011EntidadesFederativas: catalogos.PJ.C011EntidadesFederativas,
      C008TiposTemporalidad: catalogos.SIVAC.C008TiposTemporalidad,
    },
    /**
     * Método encargado de cargar valores predetermidados en caso de haberlos.
     */
    beforeMount() { 
      
      if(this.VisualizarProcesadosBaja.ExpedientesProcesados)
        this.partidoJudicialNombre = this.VisualizarProcesadosBaja.ExpedientesProcesados;

      if(this.VisualizarProcesadosBaja.ExpedientesProcesados)
        this.materiaNombre = this.VisualizarProcesadosBaja.ExpedientesProcesados;

      if(this.VisualizarProcesadosBaja.DelitosProcesados)
        this.delitoNombre = this.VisualizarProcesadosBaja.DelitosProcesados;

      if(this.VisualizarProcesadosBaja.ExpedientesProcesados)
        this.areaNombre = this.VisualizarProcesadosBaja.ExpedientesProcesados

      if(this.VisualizarProcesadosBaja.ExpedientesProcesados)
        this.tipoDocumentoNombre = this.VisualizarProcesadosBaja.ExpedientesProcesados;

      if(this.VisualizarProcesadosBaja.ExpedientesProcesados)
        this.consecutivo = this.VisualizarProcesadosBaja.ExpedientesProcesados;

      if(this.VisualizarProcesadosBaja.Municipio.Nombre)
        this.municipioNombre = this.VisualizarProcesadosBaja.Municipio.Nombre;

      if(this.VisualizarProcesadosBaja.EntidadFederativa.Nombre)
        this.entidadFederativaNombre = this.VisualizarProcesadosBaja.EntidadFederativa.Nombre;

      if(this.VisualizarProcesadosBaja.TipoTemporalidad.Temporalidad)
        this.temporalidadNombre = this.VisualizarProcesadosBaja.TipoTemporalidad.Temporalidad;

      if(this.VisualizarProcesadosBaja.FechaDeAlta)
        this.fechaDeAlta = moment(this.VisualizarProcesadosBaja.FechaDeAlta).locale('es').format('LL');

      if(this.VisualizarProcesadosBaja.FechaDeBaja)
        this.fechaDeBaja = moment(this.VisualizarProcesadosBaja.FechaDeBaja).locale('es').format('LL');

      if(this.VisualizarProcesadosBaja.ClaveDelProcesado)
        this.clave_del_procesado = this.VisualizarProcesadosBaja.ClaveDelProcesado;

      if(this.VisualizarProcesadosBaja.Nombre)
        this.nombre = this.VisualizarProcesadosBaja.Nombre;

      if(this.VisualizarProcesadosBaja.ApellidoPaterno)
        this.apellido_paterno = this.VisualizarProcesadosBaja.ApellidoPaterno;

      if(this.VisualizarProcesadosBaja.ApellidoMaterno)
        this.apellido_materno = this.VisualizarProcesadosBaja.ApellidoMaterno;

      if(this.VisualizarProcesadosBaja.Direccion)
        this.direccion = this.VisualizarProcesadosBaja.Direccion;

      
      
    },
    methods: {
     
      /** 
       * Metodo encargado de obtener el valor del item seleccionado en el catalogo 007TiposEstatusFirma
       * @param {object} evento [evento emitido por el catalogo]
       */
      cambioTipoEstatusFirma: function (evento) {
        this.tipoEstatusFirmaId = parseInt(evento.target.value);
      },

      cambioDePartidoJudicial: function (evento) {
        this.partidoJudicialId = parseInt(evento.target.value);
      },

      cambioDeMateria: function (evento) {
        this.materiaId = parseInt(evento.target.value);
      },

      cambioDeDelito: function (evento) {
        this.delitoId = parseInt(evento.target.value);
      },

      cambioDeArea: function (evento) {
        this.areaId = parseInt(evento.target.value);
      },

      cambioDeTipoDeDocumento: function (evento) {
        this.tipoDocumentoId = parseInt(evento.target.value);
      },

      cambioDeEntidad: function (evento) {
        this.entidadFederativaId = parseInt(evento.target.value);
      },

      cambioDeMunicipio: function (evento) {
        this.municipioId = parseInt(evento.target.value);
      },

      cambioDeTemporalidad: function (evento) {
        this.temporalidadId = parseInt(evento.target.value);
      },


      // *
      //  * Método encargado de actualizar/cambiar el campo del Consecutivo.
      //  * @param {event.target} datos [datos: nuevo valor del Consecutivo]
       
      cambioDeConsecutivo(datos) { 
        this.$store.dispatch("A_Comun_Consecutivo", datos.target.value);
      },
      



      /** 
       * Método encargado de llamar API para obtener id's de los tipos de documentos disponibles dependiendo de la base de datos.
       */
      obtenerFiltradoTipoDeDocumentosAPI()
      {
        comun.SeEstaCargandoInformacion(true);                
        
        const parametros = {          
          MateriaId: this.parametros_Materia.materiaId,
          AreaId: this.parametros_Area.areaId,
          EsPrueba: this.enumeraciones.EsPrueba,
        }
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

        axios
          .post(
            api.conexion + api.SIVAC.sistema.administracion.firmas.ObtenerTiposDeDocumentosIdYDBId, 
            parametros, 
            headerPeticion)
          .then(respuesta => 
          {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) 
            {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else 
            {
              this.parametros_TipoDocumento.parametros.elementosAConservar = respuesta.data.TiposDeDocumentosIds;
              this.baseDeDatosId = respuesta.data.BaseDeDatosId;
              this.parametros_TipoDocumento.key = "elementosAConservar_" + respuesta.data.TiposDeDocumentosIds.length;
            }        
          })
          .catch(e => 
          {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      },     
      




/////////////////////////////////////////////////////////////////////////////////////////

      /** 
       * Metodo encargado de verificar que todos los campos requeridos estén llenos
       * @param {object} evento [evento emitido por el catalogo]
       */
      camposLlenos:function()
      {
        
        if (!this.partidoJudicialId || this.partidoJudicialId <= 0) 
          return false;

        if (!this.materiaId || this.materiaId <= 0) 
          return false;

        if (!this.delitoId || this.delitoId <= 0) 
          return false;

        if (!this.areaId || this.areaId <= 0) 
          return false;

        if (!this.tipoDocumentoId || this.tipoDocumentoId <= 0) 
          return false;

        if (!this.entidadFederativaId || this.entidadFederativaId <= 0) 
          return false;

        if (!this.municipioId || this.municipioId <= 0) 
          return false;

        if (!this.temporalidadId || this.temporalidadId <= 0) 
          return false;

        if (!this.nombre || this.nombre <= 0) 
          return false;

        if (!this.apellido_paterno || this.apellido_paterno <= 0) 
          return false;

        if (!this.apellido_materno || this.apellido_materno <= 0) 
          return false;

        if (!this.direccion || this.direccion <= 0) 
          return false;

        if (!this.consecutivo || this.consecutivo <= 0) 
          return false;



        
        return true;
      },
      
      
      /**
       * Función encargada de verificar que el campo proporcionado tenga un valor valido.  
       * @param {string/int/other} campo 
       */
      campoRequeridoEsValido: function(campo) {
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
      
      
      


      Botoncancelar:function()
      {

       
     
          bootbox.confirm({
            title: "Mensaje del sistema",
            message: "Está por salir de la visualización del procesado.<br />¿Desea salir?",
            buttons: {
              cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No'
              },
              confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si'
              }
            },
            callback: (respuestaContinuar) => {
              if (respuestaContinuar) {

                this.$emit("botoncancelar2");

                if(respuestaContinuar){      


                }

                
              }
            }
          });


               

      }
      



    },
    computed: {
     
    }
  }
</script>
<style scoped>
  .contenedor-puntero {
    background: #212529;
    border-radius:2px;
    padding: 10px;
    border:1px solid white;
    margin-bottom: 1.5em;
  }
  .form-control:disabled, .form-control[readonly]
  {
    background-color: #3D3C40 !important;
    pointer-events: none;
    color: #aaa;
  }
  ul { 
    list-style: none;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .contenedor-color-gris {        
        background-color: #9ea1a3;
        /*box-shadow: 0px 6px 20px 8px #161616;*/
        padding: 25px
    }

  .catalogoInformativo {
      pointer-events:none;
      cursor: not-allowed;
      opacity: 0.7;
  }  
</style>



// WEBPACK FOOTER //
// src/components/SIVAC/Firmas/VisualizarProcesadoBaja.vue